import { getLocalStorageItem, setLocalStorageItem } from '../../../common/utils/localStorageHelpers'
import { makeLink, parseLocation } from '../../../common/utils/urlHelper'

class RecentSearch {
  public static addItem(item: string): void {
    const recentSearch = getLocalStorageItem(RecentSearch.RECENT_SEARCH, [])
    RecentSearch.updateRecentSearch(recentSearch, item)
  }

  public static getRecentSearch(): any[] {
    const recentSearch = getLocalStorageItem(RecentSearch.RECENT_SEARCH, [])
    return recentSearch.map((item: string) => RecentSearch.createSuggestion(item))
  }

  private static readonly RECENT_SEARCH = 'recentSearch'
  private static readonly MAX_COUNT = 5

  private static updateRecentSearch(recentSearch: string[], item: string) {
    if(recentSearch.includes(item)) {
      RecentSearch.bringItemToFront(recentSearch, item)
    }
    else {
      RecentSearch.ensureItemCount(recentSearch, RecentSearch.MAX_COUNT-1)
      recentSearch.unshift(item)
    }
    setLocalStorageItem(RecentSearch.RECENT_SEARCH, recentSearch)
  }

  private static bringItemToFront(recentSearch: string[], item: string): void {
    const itemIndex = recentSearch.indexOf(item)
    recentSearch.splice(itemIndex, 1)
    recentSearch.unshift(item)
  }

  private static ensureItemCount(recentSearch: string[], maxCount: number): void {
    if(recentSearch.length > maxCount) {
      recentSearch.pop()
    }
  }

  private static createSuggestion(item: string): {} {
    const nextQueries = { ...parseLocation(location), term: item }

    const link = makeLink(nextQueries)
    return {
      link,
      text: item,
    }
  }
}

export default RecentSearch



// WEBPACK FOOTER //
// ./client/components/autosuggest/recentSearch.ts